export default "__VITE_ASSET__19e78d4e__"